import { render } from "./WarekiInput.vue?vue&type=template&id=52c66b22"
import script from "./WarekiInput.vue?vue&type=script&lang=js"
export * from "./WarekiInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/WarekiInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52c66b22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52c66b22', __exports__)) {
    api.reload('52c66b22', __exports__)
  }
  
  module.hot.accept("./WarekiInput.vue?vue&type=template&id=52c66b22", () => {
    api.rerender('52c66b22', render)
  })

}


export default __exports__